import _getStyle from './getStyle';
export { _getStyle as getStyle };
import _removeStyle from './removeStyle';
export { _removeStyle as removeStyle };
import _addStyle from './addStyle';
export { _addStyle as addStyle };
import _getComputedStyle from './getComputedStyle';
export { _getComputedStyle as getComputedStyle };